import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';

const Component = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell className="adv_sub">ID заявки</TableCell>
                <TableCell className="role">Роль</TableCell>
                <TableCell className="city_id">Код города</TableCell>
                <TableCell className="city_name">Город</TableCell>
                <TableCell className="stage">Этап</TableCell>
                <TableCell className="last_result">Результат</TableCell>
                <TableCell className="last_reason">Причина</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default Component;
